import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material";
import { OpenVideo } from "../billboard/openvideo";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent extends OpenVideo implements OnInit {
  @Input() pageConfig: any;
  @Input() localStrings: Array<any>;
  @Input() isHotelPromotion: string;
  @Input() promotionAlias: string;
  @Output() onOpenModal = new EventEmitter();

  copywriteText: string;

  currYear = new Date().getFullYear();
  urlBase: string;

  constructor(public dialog: MatDialog) {
    super(dialog);
  }

  scrollToTop(_e) {
    if (_e.type === "click" || (_e.type === "keyup" && _e.which === 13)) {
      window.scrollTo({
        top: 100,
        behavior: "smooth",
      });
    }
  }

  ngOnInit() {
    this.urlBase = `${this.isHotelPromotion ? "/hotel" : ""}/${
      this.promotionAlias
    }`;

    this.copywriteText = this.localStrings["AV.Promotion.Copyright"].replace(
      "{{Y}}",
      this.currYear
    );
  }

  openModal(modalName: string) {
    this.onOpenModal.emit(modalName);
  }
}
